import api from './interceptor';
import { serializeSearchParams } from '../helpers/serializeSearchParams';

const BASE_URL_V2 = 'api/v2/pharmacies';

export default {
  // API Version 2
  refreshPrescribeToken: params => api.get(`${BASE_URL_V2}/ui`, { params }),
  searchPharmacies: params => api.get(`${BASE_URL_V2}/search`, { params, paramsSerializer: serializeSearchParams }),
  searchPharmaciesPaginated: params => api.get(`${BASE_URL_V2}/search/paginated`, { params, paramsSerializer: serializeSearchParams }),
  addPharmacy: params => api.post(`${BASE_URL_V2}`, params),
  getPatientPharmacies: params => api.get(`${BASE_URL_V2}`, { params }),
  removePharmacy: params => api.delete(`${BASE_URL_V2}`, { data: params }),
};
